import FaIcon, { faSliders, faXmark } from '@/components/icon/FaIcon/FaIcon';
import styles from './ItemFilterTrigger.module.scss';

type Props = {
  label: string;
  selectedProductName?: string;
  onOpen: () => void;
  onClear: () => void;
  disabled?: boolean;
};

/**
 * アイテムフィルターの起動UI（絞り込みボタン ＋ 選択中プロダクトのクリアチップ）。
 * 作品詳細（MaterialContainer）とみんなのデザイン一覧（UserDesignGridSection）で共通利用する。
 * 外側の余白は使う側で制御する（最外層に margin を持たせない）。
 */
function ItemFilterTrigger({ label, selectedProductName, onOpen, onClear, disabled = false }: Props) {
  const hasSelectedProduct = selectedProductName !== undefined && selectedProductName !== '';

  return (
    <div className={styles.root}>
      <button type='button' className={styles.button} onClick={onOpen} disabled={disabled}>
        <FaIcon icon={faSliders} />
        {label}
      </button>
      {hasSelectedProduct && (
        <button type='button' className={styles.chip} onClick={onClear}>
          {selectedProductName}
          <FaIcon icon={faXmark} />
        </button>
      )}
    </div>
  );
}

export default ItemFilterTrigger;
